'use client';

import React, { ElementType, JSX } from 'react';
import { MagnoliaComponentNode, PageProps } from '@/Util/magnolia';
import { LinkTypeProps } from './Link';
import { MgnlContent } from '@magnolia/frontend-helpers-base';
import { EditableArea } from '@magnolia/react-editor';
import { EditableComponent } from '@magnolia/react-editor';

interface MagnoliaComponentNodeLinkLIST extends Omit<MagnoliaComponentNode, '@nodes'> {
  '@nodes': string[];
}

type ListType = 'bullet' | 'ordered' | 'inline';

const LinkList = (props: {
  links?: MgnlContent;
  subTitle: string;
  listStyle: ListType;
  pageProps: PageProps;
}): JSX.Element => {
  const { links, subTitle, listStyle = 'bullet', pageProps } = props;
  const Tag = tag[listStyle];
  return (
    <div className={'link-list'}>
      {subTitle ? <h4>{subTitle}</h4> : null}
      <Tag className={`${listStyle === 'inline' ? 'list-inline' : ''}`}>
        {!!links ? <EditableArea content={links} customView={LinkListElement} /> : <></>}
      </Tag>
    </div>
  );
};

function LinkListElement({
  content,
  pageProps
}: {
  content: { [_: string]: LinkTypeProps } & MagnoliaComponentNodeLinkLIST;
  pageProps: PageProps;
}) {
  return (
    <>
      {content['@nodes'].map(nodeName => (
        <li key={content[nodeName]['@id'] as string}>
          <EditableComponent content={content[nodeName] as unknown as MgnlContent} />
        </li>
      ))}
    </>
  );
}

const tag: { [a in ListType]: ElementType } = {
  bullet: 'ul',
  ordered: 'ol',
  inline: 'ul'
};

export default LinkList;
